<template>
    <article>
        <!--
            We override the main container style because it's too restricting.
            Doing this in the template allows to not break other views.
        -->
        <v-style>
            #app > .builderContainer { display: block; } #builderWrapper { height: 100%; width: 100%; } .content-builder-main { position: unset; }
        </v-style>

        <MenuBar background-color-active="#A2A2A2">
            <MenuItemPlano icon="fas fa-file-pdf" :size="50" :width="400" :action="exportPdf" :text="$t('planobuilder.export')"></MenuItemPlano>
        </MenuBar>
        <section>
            <TemplatePlano class="plano" :data="getMeuble"></TemplatePlano>
            <!-- must be placed after TemplatePlano, to make sure it catches pointer events -->
            <aside>
                <ul class="listNone listAction">
                    <li class="selection" :class="{ on: !isPan }" @click="activeSelection"></li>
                    <li class="pan" :class="{ on: isPan }" @click="activePan"></li>
                </ul>
                <ul class="listNone listZoom">
                    <li @click="zoomComponent" class="zoom-position" :class="{ on: isZoomComponent() }"></li>
                    <li class="zoom-extent" @click="planoInit"></li>
                </ul>
                <ul class="listNone listOption">
                    <li class="icon-layers snap" @click="activeSnapMod" :class="{ on: hasSnapMod }"></li>
                    <li v-if="!isCaddySystem" class="icon-layers overhang" @click="activeOverHang" :class="{ on: hasOverHang }"></li>
                    <li v-if="!isCaddySystem" class="icon-layers span" @click="activeOverHang" :class="{ on: hasOverHang }"></li>
                    <li class="icon-layers free-position" @click="activeFreePosition" :class="{ on: isFreePosition }"></li>
                </ul>

                <ul class="listNone listLayers">
                    <li class="icon-layers layers" @click="activeLayers" :class="{ on: isActiveLayer }"></li>
                </ul>
            </aside>
        </section>

        <MenuBar id="menu_plano_massmarket" background-color-active="#A2A2A2">
            <MenuItemPlano id="menuitem_plano_massmarket_lib" icon="fas fa-grip-vertical" :size="50" :width="400" :text="$t('planobuilder.library')">
                <Elements class="menu-element" :plano="1" />
            </MenuItemPlano>
            <MenuItemPlano id="menuitem_plano_massmarket_scratchpad" icon="fas fa-paste" :size="50" :width="400" :text="$t('planobuilder.scratch')">
                <Favorite type="SCRATCHPAD" :idPlano="parseInt($route.params.id, 10)" typePlano="WALL"></Favorite>
            </MenuItemPlano>
            <MenuItemPlano id="menuitem_plano_massmarket_fav" icon="fas  fa-bookmark" :size="50" :width="400" :text="$t('planobuilder.favorite')">
                <Favorite typePlano="WALL"></Favorite>
            </MenuItemPlano>
        </MenuBar>
    </article>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import TemplateMassMarket from './common/TemplateMassMarket'
import Favorite from "./menu/Favorite";
import TemplatePlano from "./common/TemplatePlano";
import Elements from "./common/Elements";
import MenuBar from "../gui/menu/MenuBar";
import MenuItemPlano from "../gui/menu/MenuItem";
import ScratchPad from "./menu/ScratchPad";
import Globals from "../globals";
import cacheService from "@/services/cache";
import { carcassmodel } from "@/store/planonext/carcassmodel";

export default {
    components: {
        // TemplateMassMarket,
        TemplatePlano,
        Elements,
        MenuBar,
        MenuItemPlano,
        Favorite,
        ScratchPad
    },
    data() {
        return {};
    },
    computed: {
        ...mapGetters("plano/data", {
            getMeuble: "getMeuble",
            planoDetails: "getPlanoDetails",
            isCaddySystem: "isCaddySystem"
        }),

        ...mapGetters("plano/status", {
            getMode: "getMode",
            isActiveLayer: "isActiveLayer",
            hasOverHang: "hasOverHang",
            hasSnapMod: "hasSnapMod",
            isFreePosition: "isFreePosition",
            isPan: "isPan"
        }),

        ...mapGetters("events/planomassmarket", {
            getZoomComponent: "getZoomComponent"
        })
    },
    created() {},
    mounted() {},
    methods: {
        ...mapActions("plano/status", {
            setActiveLayer: "setActiveLayer",
            setPosMenuLayer: "setPosMenuLayer",
            setOverHang: "setOverHang",
            setSnapMod: "setSnapMod",
            setPan: "setPan",
            setFreePosition: "setFreePosition"
        }),

        ...mapActions("events/planomassmarket", {
            dispatchPlanoPositionInit: "dispatchPlanoPositionInit",
            dispatchZoomComponent: "dispatchZoomComponent",
            dispatchExportPdf: "dispatchExportPdf"
        }),

        zoomComponent() {
            let { active } = this.getZoomComponent;
            active = !active;
            this.dispatchZoomComponent({ active });
        },

        isZoomComponent() {
            let { active } = this.getZoomComponent;
            return active;
        },

        activeSelection() {
            this.setPan(false);
        },

        activePan() {
            this.setPan(true);
        },

        activeLayers(e) {
            this.setActiveLayer(!this.isActiveLayer);
            this.setPosMenuLayer(e.target.getBoundingClientRect());
        },

        activeOverHang() {
            let overHang = !this.hasOverHang;
            this.setOverHang(overHang);
        },

        activeSnapMod() {
            let snap = !this.hasSnapMod;
            this.setSnapMod(snap);
        },

        planoInit() {
            this.dispatchPlanoPositionInit({});
        },

        activeFreePosition() {
            this.setFreePosition(!this.isFreePosition);
        },
        exportPdf() {
            this.dispatchExportPdf({});
        }
    }
};
</script>

<style scoped lang="scss">
article {
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: space-between;
}

.content-plano-massmarket {
    height: 100%;

    .content-list-action {
        margin-top: 20px;
    }

    .content-template-massmarket {
        padding-top: 50px;
    }
}

section {
    flex-grow: 1;
    position: relative;
}

aside {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    padding-top: 20px;

    ul.listNone {
        padding: unset;
        padding-left: 20px;
    }

    ul.listAction {
        margin: auto;
        li {
            margin-bottom: 20px;
            background-color: #fff;
            width: 40px;
            height: 40px;
            &.selection {
                background-image: url("../../assets/selection-off.svg");
                &.on {
                    background-image: url("../../assets/selection-on.svg");
                }
            }
            &.pan {
                background-image: url("../../assets/pan-off.svg");
                &.on {
                    background-image: url("../../assets/pan-on.svg");
                }
            }

            &.icon-ungroup {
                background-image: url("../../assets/ungroup-off.svg");
                &.on {
                    background-image: url("../../assets/ungroup-on.svg");
                }
            }
        }
    }

    ul.listZoom {
        li {
            background-color: #ffffff;
            width: 40px;
            height: 40px;
            margin-bottom: 2px;

            &.zoom-position {
                background-image: url("../../assets/zoom-position-off.svg");
                &.on {
                    background-image: url("../../assets/zoom-position-on.svg");
                }
            }

            &.zoom-extent {
                background-image: url("../../assets/zoom-extent-off.svg");
                &:active {
                    background-image: url("../../assets/zoom-extent-on.svg");
                }
            }
        }
    }

    ul.listOption {
        margin-top: 20px;

        li {
            background-color: #ffffff;
            width: 40px;
            height: 40px;
            margin-bottom: 2px;

            &.overhang {
                background-image: url("../../assets/overhang-off.svg");
                &.on {
                    background-image: url("../../assets/overhang-on.svg");
                }
            }

            &.span {
                background-image: url("../../assets/span-off.svg");
                &.on {
                    background-image: url("../../assets/span-on.svg");
                }
            }

            &.snap {
                background-image: url("../../assets/snap-off.svg");
                &.on {
                    background-image: url("../../assets/snap-on.svg");
                }
            }
            &.free-position {
                background-image: url("../../assets/free-positioning-off.svg");
                &.on,
                &:active {
                    background-image: url("../../assets/free-positioning-on.svg");
                }
            }
        }
    }

    ul.listLayers {
        margin-top: 20px;
        li {
            background-color: #ffffff;
            width: 40px;
            height: 40px;

            &.layers {
                background-image: url("../../assets/layers1-off.svg");
                &.on {
                    background-image: url("../../assets/layers1-on.svg");
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// PlanoEditorMassMarket.vue?41b4b9e8